module.exports = __webpack_public_path__ + "img/metajuana-staking-lab.cd8b3c98.png";